import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

class Icon extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    icons = {
        select: (
            <svg viewBox="0 0 14 8" fill="none">
                <path
                    d="M1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311 0.683417 -0.0976311 1.31658 0.292893 1.70711L6.29289 7.70711C6.68342 8.09763 7.31658 8.09763 7.70711 7.70711L13.7071 1.70711C14.0976 1.31658 14.0976 0.683417 13.7071 0.292893C13.3166 -0.0976311 12.6834 -0.0976311 12.2929 0.292893L7 5.58579L1.70711 0.292893Z"
                    fill="#171A24"
                    className="icon__fill"
                />
            </svg>
        ),
        search: (
            <svg viewBox="0 0 18 20" fill="none">
                <path
                    d="M12.8008 14.3334L16.0008 17.5334"
                    stroke="#5C0F8B"
                    strokeWidth="3"
                    strokeLinecap="round"
                    className="icon__stroke"
                />
                <circle
                    cx="8"
                    cy="8.46667"
                    r="6.5"
                    stroke="#5C0F8B"
                    strokeWidth="3"
                    className="icon__stroke"
                />
            </svg>
        ),
        check: (
            <svg viewBox="0 0 14 10" fill="none">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.1813 0.675393C13.5615 1.07599 13.5449 1.70894 13.1443 2.08912L5.3821 9.4557L0.858499 5.16268C0.457898 4.7825 0.441344 4.14955 0.821525 3.74895C1.20171 3.34835 1.83465 3.33179 2.23526 3.71197L5.3821 6.69842L11.7676 0.63842C12.1682 0.258239 12.8011 0.274793 13.1813 0.675393Z"
                    className="icon__fill"
                    fill="#fff"
                />
            </svg>
        ),
        upload: (
            <svg viewBox="0 0 24 24" fill="none">
                <path
                    d="M12.0003 2.85718V14.8572M12.0003 14.8572L6.85742 9.71432M12.0003 14.8572L17.1431 9.71432"
                    stroke="black"
                    strokeWidth="1.7"
                    strokeLinecap="round"
                    className="icon__stroke"
                />
                <path
                    d="M2.57129 16.2857V20.7143C2.57129 21.8188 3.46672 22.7143 4.57129 22.7143H18.9999C20.1044 22.7143 20.9999 21.8188 20.9999 20.7143V16.2857"
                    stroke="black"
                    strokeWidth="1.7"
                    strokeLinecap="round"
                    className="icon__stroke"
                />
            </svg>
        ),
        close: (
            <svg viewBox="0 0 19 19" fill="none">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.21937 1.21961C1.80516 0.633827 2.7549 0.633827 3.34069 1.21961L9.42003 7.29895L15.4994 1.21961C16.0852 0.633827 17.0349 0.633827 17.6207 1.21961C18.2065 1.8054 18.2065 2.75515 17.6207 3.34093L11.5413 9.42027L17.6207 15.4996C18.2065 16.0854 18.2065 17.0351 17.6207 17.6209C17.0349 18.2067 16.0852 18.2067 15.4994 17.6209L9.42003 11.5416L3.34069 17.6209C2.7549 18.2067 1.80516 18.2067 1.21937 17.6209C0.633583 17.0351 0.633583 16.0854 1.21937 15.4996L7.29871 9.42027L1.21937 3.34093C0.633583 2.75515 0.633583 1.8054 1.21937 1.21961Z"
                    fill="#721185"
                    className="icon__fill"
                />
            </svg>
        ),
        scan: (
            <svg viewBox="0 0 39 39" fill="none">
                <path
                    d="M34.7846 0H29.3262C28.6952 0 28.1836 0.51157 28.1836 1.14258C28.1836 1.77359 28.6952 2.28516 29.3262 2.28516H34.7846C35.8489 2.28516 36.7148 3.15108 36.7148 4.21543V9.67383C36.7148 10.3048 37.2264 10.8164 37.8574 10.8164C38.4884 10.8164 39 10.3048 39 9.67383V4.21543C39 1.89104 37.109 0 34.7846 0V0Z"
                    fill="#5F2589"
                    className="icon__fill"
                />
                <path
                    d="M1.14258 10.8164C1.77359 10.8164 2.28516 10.3048 2.28516 9.67383V4.21543C2.28516 3.15108 3.15108 2.28516 4.21535 2.28516H9.67383C10.3048 2.28516 10.8164 1.77359 10.8164 1.14258C10.8164 0.51157 10.3048 0 9.67383 0H4.21535C1.89104 0 0 1.89104 0 4.21543V9.67383C0 10.3048 0.51157 10.8164 1.14258 10.8164Z"
                    fill="#5F2589"
                    className="icon__fill"
                />
                <path
                    d="M9.67383 36.7148H4.21535C3.15108 36.7148 2.28516 35.8489 2.28516 34.7846V29.3262C2.28516 28.6952 1.77359 28.1836 1.14258 28.1836C0.51157 28.1836 0 28.6952 0 29.3262V34.7846C0 37.109 1.89104 39 4.21535 39H9.67383C10.3048 39 10.8164 38.4884 10.8164 37.8574C10.8164 37.2264 10.3048 36.7148 9.67383 36.7148Z"
                    fill="#5F2589"
                    className="icon__fill"
                />
                <path
                    d="M37.8574 28.1836C37.2264 28.1836 36.7148 28.6952 36.7148 29.3262V34.7846C36.7148 35.8489 35.8489 36.7148 34.7846 36.7148H29.3262C28.6952 36.7148 28.1836 37.2264 28.1836 37.8574C28.1836 38.4884 28.6952 39 29.3262 39H34.7846C37.109 39 39 37.109 39 34.7846V29.3262C39 28.6952 38.4884 28.1836 37.8574 28.1836Z"
                    fill="#5F2589"
                    className="icon__fill"
                />
                <path
                    d="M26.0217 8.37891H29.6456C30.1405 8.37891 30.5431 8.78147 30.5431 9.27636V12.9002C30.5431 13.5312 31.0546 14.0427 31.6856 14.0427C32.3166 14.0427 32.8282 13.5312 32.8282 12.9002V9.27636C32.8282 7.52144 31.4005 6.09375 29.6456 6.09375H26.0217C25.3907 6.09375 24.8792 6.60532 24.8792 7.23633C24.8792 7.86734 25.3907 8.37891 26.0217 8.37891Z"
                    fill="#5F2589"
                    className="icon__fill"
                />
                <path
                    d="M6.16992 9.27636V12.9002C6.16992 13.5312 6.68149 14.0427 7.3125 14.0427C7.94351 14.0427 8.45508 13.5312 8.45508 12.9002V9.27636C8.45508 8.78147 8.85772 8.37891 9.35254 8.37891H12.9764C13.6074 8.37891 14.119 7.86734 14.119 7.23633C14.119 6.60532 13.6074 6.09375 12.9764 6.09375H9.35254C7.59769 6.09375 6.16992 7.52144 6.16992 9.27636Z"
                    fill="#5F2589"
                    className="icon__fill"
                />
                <path
                    d="M12.9764 30.4685H9.35254C8.85765 30.4685 8.45508 30.066 8.45508 29.5711V25.9473C8.45508 25.3163 7.94351 24.8047 7.3125 24.8047C6.68149 24.8047 6.16992 25.3163 6.16992 25.9473V29.5711C6.16992 31.326 7.59769 32.7537 9.35254 32.7537H12.9764C13.6074 32.7537 14.119 32.2421 14.119 31.6111C14.119 30.9801 13.6074 30.4685 12.9764 30.4685Z"
                    fill="#5F2589"
                    className="icon__fill"
                />
                <path
                    d="M32.8282 29.5711V25.9473C32.8282 25.3163 32.3166 24.8047 31.6856 24.8047C31.0546 24.8047 30.5431 25.3163 30.5431 25.9473V29.5711C30.5431 30.066 30.1404 30.4685 29.6456 30.4685H26.0217C25.3907 30.4685 24.8792 30.9801 24.8792 31.6111C24.8792 32.2421 25.3907 32.7537 26.0217 32.7537H29.6456C31.4005 32.7537 32.8282 31.326 32.8282 29.5711Z"
                    fill="#5F2589"
                    className="icon__fill"
                />
                <path
                    d="M0.0761719 19.5C0.0761719 20.131 0.587742 20.6426 1.21875 20.6426H37.7812C38.4123 20.6426 38.9238 20.131 38.9238 19.5C38.9238 18.869 38.4123 18.3574 37.7812 18.3574H1.21875C0.587742 18.3574 0.0761719 18.869 0.0761719 19.5Z"
                    fill="#5F2589"
                    className="icon__fill"
                />
            </svg>
        ),
        'arrow-prev': (
            <svg viewBox="0 0 13 20" fill="none">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.171875 10L9.58609 0.585787C10.3671 -0.195263 11.6335 -0.195263 12.4145 0.585787C13.1956 1.36683 13.1956 2.63316 12.4145 3.41421L5.82873 10L12.4145 16.5858C13.1956 17.3668 13.1956 18.6332 12.4145 19.4142C11.6335 20.1953 10.3671 20.1953 9.58609 19.4142L0.171875 10Z"
                    fill="white"
                    className="icon__fill"
                />
            </svg>
        ),
        'arrow-next': (
            <svg viewBox="0 0 13 20" fill="none">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.8281 10L3.41391 0.585787C2.63286 -0.195263 1.36653 -0.195263 0.585484 0.585787C-0.195564 1.36683 -0.195564 2.63316 0.585484 3.41421L7.17127 10L0.585484 16.5858C-0.195564 17.3668 -0.195564 18.6332 0.585484 19.4142C1.36653 20.1953 2.63286 20.1953 3.41391 19.4142L12.8281 10Z"
                    fill="white"
                    className="icon__fill"
                />
            </svg>
        ),
    };

    render() {
        return (
            <div className="icon">
                {this.icons[this.props.name] ? this.icons[this.props.name] : null}
            </div>
        );
    }
}

function mapStateToProps() {
    return {};
}

export default connect(mapStateToProps)(Icon);

Icon.propTypes = {
    info: PropTypes.object,
    name: PropTypes.string,
    data: PropTypes.object,
};
